import React, { useState } from "react";
import "./style.scss";
import SvgBrand from "../assets/SvgBrand";
import { BiLogoPinterestAlt } from "react-icons/bi";
import { SvgFooterFacebook } from "assets/icons/js/SvgFooterFacebook";
import { SvgFooterInsta } from "assets/icons/js/SvgFooterInsta";
import { SvgFooterLinkdin } from "assets/icons/js/SvgFooterLinkdin";
import { SvgFooterTwitter } from "assets/icons/js/SvgFooterTwitter";
import { SvgFooterYoutube } from "assets/icons/js/SvgFooterYoutube";
import clevertap from "clevertap-web-sdk";
import SEOFooter from "../Seo";

const FooterMobile = () => {
	return (
		<div className="footer-mob-wrapper">
			<SEOFooter />

			<div className="footer-mob-container">
				<div className="footer-mob-content">
					<div className="footer-mob-brand">
						<div className="footer-mob-brand-left">
							<div className="footer-mob-brand-logo">
								<SvgBrand />
							</div>
							<p>
								© {new Date().getFullYear()} SaffronStays. All rights reserved
							</p>
						</div>
						<div className="footer-mob-brand-right">
							<div className="footer-mob-socials">
								<a
									aria-label="Fb"
									href="https://www.facebook.com/saffronstays"
									target="_blank"
									rel="noreferrer"
									onClick={() => {
										clevertap.event.push("social_media_links", {
											timestamp: new Date(),
											type: "Facebook",
										});
									}}
								>
									<SvgFooterFacebook />
								</a>
								<a
									aria-label="Twitter"
									href="https://twitter.com/saffronstays"
									target="_blank"
									rel="noreferrer"
									onClick={() => {
										clevertap.event.push("social_media_links", {
											timestamp: new Date(),
											type: "Twitter",
										});
									}}
								>
									<SvgFooterTwitter />
								</a>
								<a
									aria-label="Linkedin"
									href="https://www.linkedin.com/company/saffronstays"
									target="_blank"
									rel="noreferrer"
									onClick={() => {
										clevertap.event.push("social_media_links", {
											timestamp: new Date(),
											type: "Linkedin",
										});
									}}
								>
									<SvgFooterLinkdin />
								</a>
								<a
									aria-label="Instagram"
									href="https://www.instagram.com/saffronstays/"
									target="_blank"
									rel="noreferrer"
									onClick={() => {
										clevertap.event.push("social_media_links", {
											timestamp: new Date(),
											type: "Instagram",
										});
									}}
								>
									<SvgFooterInsta />
								</a>
								<a
									aria-label="Youtube"
									href="https://www.youtube.com/channel/UC0lvPYqLKtJ_GkoCG-YPY0A"
									target="_blank"
									rel="noreferrer"
									onClick={() => {
										clevertap.event.push("social_media_links", {
											timestamp: new Date(),
											type: "Youtube",
										});
									}}
								>
									<SvgFooterYoutube />
								</a>
								<a
									aria-label="Pinterest"
									href="https://pin.it/3o3iGHe"
									target="_blank"
									rel="noreferrer"
									style={{ fontSize: "19px", color: "white" }}
									onClick={() => {
										clevertap.event.push("social_media_links", {
											timestamp: new Date(),
											type: "Pinterest",
										});
									}}
								>
									<BiLogoPinterestAlt />
								</a>
							</div>
						</div>
					</div>
					{/* <div className="footer-mob-menu">
						<div className="footer-mob-menu-col1">
							{menuColumns?.slice(0, 3)?.map((ele) => {
								return (
									<div className="footer-mob-column">
										<p>{ele?.column}</p>
										<div className="footer-mob-sub-column">
											{ele?.links.map((elem, index) => {
												return (
													<a href={ele?.slugs[index]}>
														<p>{elem}</p>
													</a>
												);
											})}
										</div>
									</div>
								);
							})}
						</div>
						<div className="footer-mob-menu-col1">
							{menuColumns?.slice(3, 4)?.map((ele) => {
								return (
									<div className="footer-mob-column">
										<p>{ele?.column}</p>
										<div className="footer-mob-sub-column">
											{ele?.links.map((elem, index) => {
												return (
													<a href={ele?.slugs[index]}>
														<p>{elem}</p>
													</a>
												);
											})}
										</div>
									</div>
								);
							})}
						</div>
					</div> */}
				</div>
			</div>
		</div>
	);
};

export default FooterMobile;
